/*
 * Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character
 */

export const passwordRegex = new RegExp(
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-]).{8,30}$/
)

export const withoutSpecificCharRegex = new RegExp(
    /^[A-Za-z\d!@#$%^&*?-]{1,30}$/
)

export const alphabetsRegex = new RegExp(/^([a-zA-Z\s])+$/)

export const postalCodeRegex = new RegExp(
    /^[a-zA-Z0-9](?:[a-zA-Z0-9- ]{0,10}[a-zA-Z0-9])?$/
)

export const alphaNumeric = new RegExp(/^[-a-zA-Z0-9]+(\s+[-a-zA-Z0-9]+)*$/)

export const emptyOrAlphaNumeric = new RegExp(/(^$)|(^[a-zA-Z0-9? ,_-]+$)/)

export const isContainNumeric = new RegExp(/^\d+$/)

export const isMobile = new RegExp(/Android|iPhone/i)

export const UPPERCASE_REGEX = new RegExp(/^(?=.*?[A-Z])/)
export const LOWERCASE_REGEX = new RegExp(/^(?=.*?[a-z])/)
export const NUMBER_REGEX = new RegExp(/^(?=.*?\d+)/)
export const LENGTH_REGEX = new RegExp(/^.{8,30}$/)
export const SPECIAL_CHARS_REGEX = new RegExp(/^(?=.*?[#?!@$%^&*-])/)

// Git message note allowed with ! , . and A to Z, a to z and 0 to 9
export const giftNoteRegex = new RegExp(/(^$)|(^[a-zA-Z0-9? ,_!.]+$)/)
